module.exports = __webpack_public_path__ + "img/background black.63e05bab.jpg";